import Http from '@/utils/http/index';
import { shallowClones } from '@/utils/tools/utils';

// 获取 RDR 预警列表
export function queryRDRAlertList(data) {
  const params = shallowClones(data);
  if (params.caseTypes && typeof params.caseTypes === 'string') {
    params.caseTypes = params.caseTypes.split(',');
  }
  if (params.caseTypes && params.caseTypes[0] === '') {
    delete params.caseTypes;
  } else if (params.caseTypes === '') {
    delete params.caseTypes;
  }

  if (params.statusList && typeof params.statusList === 'string') {
    params.statusList = params.statusList.split(',');
  }
  if (params.statusList && params.statusList[0] === '') {
    delete params.statusList;
  } else if (params.statusList === '') {
    delete params.statusList;
  }

  return Http.post('/rdr/agency-cw/page', params);
}

export function queryRDRAlertInfo(id) {
  return Http.get(`/rdr/agency-cw/detail/${id}`);
}

export function queryRDREnrollmentList(data) {
  const params = shallowClones(data);
  if (params.enrollmentStatusList && typeof params.enrollmentStatusList === 'string') {
    params.enrollmentStatusList = params.enrollmentStatusList.split(',');
  }
  if (params.enrollmentStatusList && params.enrollmentStatusList[0] === '') {
    delete params.enrollmentStatusList;
  } else if (params.enrollmentStatusList === '') {
    delete params.enrollmentStatusList;
  }
  return Http.post('/rdr/agency-cw/enrollment/page', params);
}

export function queryRDREnrollmentDetail(id) {
  return Http.get(`/rdr/agency-cw/enrollment/get/${id}`);
}

export function updateRDREnrollmentInfo(data) {
  return Http.post('/rdr/agency-cw/enrollment/transition', data);
}

export function addRDREnrollmentInfo(data) {
  return Http.post('/rdr/agency-cw/enrollment/save', data);
}

export function batchImportRDREnrollment(params) {
  return Http.post('/rdr/agency-cw/enrollment/batchAdd', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function downloadRDREnrollmentList(data) {
  const params = shallowClones(data);

  if (params.enrollmentStatusList && typeof params.enrollmentStatusList === 'string') {
    params.enrollmentStatusList = params.enrollmentStatusList.split(',');
  }

  if (params.enrollmentStatusList && params.enrollmentStatusList[0] === '') {
    delete params.enrollmentStatusList;
  } else if (params.enrollmentStatusList === '') {
    delete params.enrollmentStatusList;
  }
  return Http.post('/rdr/agency-cw/enrollment/download', params);
}

export function downloadRDRAlertList(data) {
  const params = shallowClones(data);
  if (params.caseTypes && typeof params.caseTypes === 'string') {
    params.caseTypes = params.caseTypes.split(',');
  }
  if (params.caseTypes && params.caseTypes[0] === '') {
    delete params.caseTypes;
  } else if (params.caseTypes === '') {
    delete params.caseTypes;
  }
  if (params.statusList && params.statusList[0] === '') {
    delete params.statusList;
  } else if (params.statusList === '') {
    delete params.statusList;
  }
  return Http.post('/rdr/agency-cw/download', params);
}
